export default __webpack_public_path__ + "static/media/macos-dock.00ee14d0.webp";